import React from "react";
import PropTypes from "prop-types";
import Analytics from "analytics/util/Analytics";
import _str from "shared/util/_str";

import SearchWithSuggestions from "shared/components/SearchWithSuggestions";

import { INTEREST_SEARCH_MAX_LENGTH } from "apps/discovery/util/consts";

import "./InterestSearch.scss";

const InterestSearch = (props) => {
	const _handleClick = (e) => {
		const data = { interest_text: e.text };
		props.getInterestMatches(data);
	};

	const _handleFocus = () => {
		Analytics.logUIEvent(Analytics.eventNames.discoveryClickedInterestSearch);
	};

	const elasticSearchProps = {
		allowArbitrarySearch: true,
		maxLength: INTEREST_SEARCH_MAX_LENGTH,
	};

	return (
		<div className="interest-search oknf oknf--blue">
			<span className="interest-search-title">
				{props.title}
			</span>
			<SearchWithSuggestions
				searchProps={{
					placeholder: _str("What are you into?"),
				}}
				results={props.isSearchingInterest ? null : props.interestResults}
				onFocus={_handleFocus}
				onResultClick={_handleClick}
				onResultsChange={() => {}}
				searchFunction={props.searchInterest}
				{...elasticSearchProps}
			/>
		</div>
	);
};

InterestSearch.propTypes = {
	title: PropTypes.string.isRequired,
	interestResults: PropTypes.array,
	searchInterest: PropTypes.func.isRequired,
	getInterestMatches: PropTypes.func.isRequired,
	isSearchingInterest: PropTypes.bool,
};

export default InterestSearch;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/headers/InterestSearch.jsx